export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20.886 7.576a1.002 1.002 0 011.38.86l.597 9.373A3 3 0 0119.87 21H2.001a1 1 0 01-1-1v-3.5c0-.403.243-.768.616-.923l19.269-8zM3 17.168V19h16.87a1 1 0 00.996-1.064L20.36 9.96 3.001 17.168z\" fill=\"#7B61FF\"/><path d=\"M7.917 9.738a4.001 4.001 0 015.154-2.332l-.706 1.872a2 2 0 00-2.576 1.166l-1.872-.706z\" fill=\"#7B61FF\"/><path d=\"M4.174 8.329A8 8 0 0114.48 3.663l-.705 1.871a6 6 0 00-7.73 3.5l-1.871-.705z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};